import { useState } from 'react';
import { db, auth } from '../../firebase/config';
import { collection, addDoc, getDocs, deleteDoc, writeBatch, doc } from 'firebase/firestore';
import { eventsList } from '../../data/events';
import { announcementsList } from '../../data/announcements';

// Hardcoded team data from TeamPage.jsx
import fatmanurImg from '../../assets/fatmanur.jpg';
import dogukanImg from '../../assets/dogukan.jpg';
import batuhanImg from '../../assets/batuhan.jpg';
import mehmetImg from '../../assets/mehmet.jpg';
import rabiaImg from '../../assets/rabia.jpg';
import edaImg from '../../assets/eda.jpg';

const teamData = [
    { name: 'Rabia CENGİZHAN', role: 'Topluluk Başkanı & YK Başkanı', category: 'baskan', image: rabiaImg }, // Added category baskan manually
    { name: 'Batuhan TURAN', role: 'Başkan Yardımcısı', category: 'yonetim', image: batuhanImg },
    { name: 'Mehmet Büyükkafalı', role: 'Başkan Yardımcısı', category: 'yonetim', image: mehmetImg },
    { name: 'Doğukan AKYOL', role: 'Denetim Kurulu Başkanı', category: 'denetim', image: dogukanImg },
    { name: 'Fatmanur SİNANOĞLU', role: 'Başkan Yardımcısı', category: 'denetim', image: fatmanurImg },
    { name: 'Eda AK', role: 'Başkan Yardımcısı', category: 'denetim', image: edaImg }
];

const pressItems = [
    {
        title: "MSKÜ, ÜniDes 2025’te 8 Projesiyle Destek Almaya Hak Kazandı",
        source: "MSKÜ Haberler",
        date: "Güncel",
        summary: "Üniversitemiz, ÜniDes 2025 kapsamında sunduğu projelerle önemli bir başarıya imza atarak destek almaya hak kazandı.",
        url: "https://www.mu.edu.tr/tr/haber/msku-unides-2025%E2%80%99te-8-projesiyle-destek-almaya-hak-kazandi-1768"
    },
    {
        title: "Turizm Rehberliği Bölümü ÜniDes Projesi",
        source: "Turizm Fakültesi",
        date: "Güncel",
        summary: "Turizm Rehberliği Bölümü tarafından hazırlanan proje, üniversitemizin desteklenen çalışmaları arasında yerini aldı.",
        url: "https://turizm.mu.edu.tr/tr/haber/turizm-rehberligi-bolumu-unides-projesi-73998?fbclid=PAb21jcAPvjlJleHRuA2FlbQIxMQBzcnRjBmFwcF9pZA81NjcwNjczNDMzNTI0MjcAAaeup4hVXDENj5vvmIXrXICplnYmUqn2YbVz2sr8GQ60U8axxTh_pu8IoNdmyg_aem_p0SEz91GZEPHetJOtYZsnw"
    },
    {
        title: "TURET Sosyal Medya Paylaşımı",
        source: "Instagram",
        date: "Güncel",
        summary: "Topluluğumuzun en güncel etkinlikleri ve duyuruları için sosyal medya hesaplarımızı takip edin.",
        url: "https://www.instagram.com/mskuturet?igsh=MTN5aG9taXRzYjEwZA=="
    },
    {
        title: "TURET Menteşe Yürüyüşü ile Tarihe Işık Tuttu",
        source: "Muğla Gazetesi",
        date: "20 Ekim 2023",
        summary: "Muğla Sıtkı Koçman Üniversitesi TURET topluluğu, Menteşe kentsel sit alanında düzenlediği yürüyüşle büyük ilgi topladı.",
        url: "#"
    },
    {
        title: "Genç Rehberler Stratonekeia'daydı",
        source: "Hürriyet Yerel",
        date: "15 Kasım 2023",
        summary: "Geleceğin turist rehberleri, gladyatörler şehri Stratonekeia antik kentinde incelemelerde bulundu.",
        url: "#"
    },
    {
        title: "TURET'ten Anlamlı Cumhuriyet Etkinliği",
        source: "Anadolu Ajansı",
        date: "29 Ekim 2023",
        summary: "Cumhuriyetin 100. yılında TURET üyeleri ellerinde bayraklarla yürüdü.",
        url: "#"
    }
];

const SeedData = () => {
    const [status, setStatus] = useState('');
    const [loading, setLoading] = useState(false);

    const clearCollection = async (collectionName) => {
        const querySnapshot = await getDocs(collection(db, collectionName));
        const deletePromises = querySnapshot.docs.map(doc => deleteDoc(doc.ref));
        await Promise.all(deletePromises);
        setStatus(prev => prev + `${collectionName} temizlendi.\n`);
    };

    const handleSeed = async () => {
        if (!window.confirm("Bu işlem veritabanındaki MEVCUT TÜM VERİLERİ SİLECEK ve static dosyalardaki verileri yükleyecektir. Emin misiniz?")) return;

        setLoading(true);
        setStatus('🚀 Başlatılıyor...\n');

        try {
            // Check data imports
            if (!eventsList || !announcementsList || !teamData) {
                throw new Error("Veri dosyaları okunamadı! (import hatası)");
            }
            setStatus(prev => prev + `📦 Veriler: Etkinlik: ${eventsList.length}, Duyuru: ${announcementsList.length}, Ekip: ${teamData.length}\n`);

            // --- 1. CLEANING ---
            const cleanCollection = async (name) => {
                setStatus(prev => prev + `🧹 ${name} temizleniyor... `);
                const q = await getDocs(collection(db, name));
                if (q.size === 0) {
                    setStatus(prev => prev + `(Boş)\n`);
                    return;
                }

                // Batch delete (max 500 ops)
                const chunks = [];
                for (let i = 0; i < q.docs.length; i += 400) {
                    chunks.push(q.docs.slice(i, i + 400));
                }

                for (const chunk of chunks) {
                    const batch = writeBatch(db);
                    chunk.forEach(doc => batch.delete(doc.ref));
                    await batch.commit();
                }
                setStatus(prev => prev + `✅\n`);
            };

            await cleanCollection('events');
            await cleanCollection('announcements');
            await cleanCollection('team');
            await cleanCollection('blogs');
            await cleanCollection('press');

            // --- 2. WRITING (Sequential with Timeout) ---
            const writeOneByOne = async (name, list) => {
                if (list.length === 0) return;
                setStatus(prev => prev + `✍️ ${name} yazılıyor (${list.length} adet)... `);

                let success = 0;
                let fail = 0;

                for (let i = 0; i < list.length; i++) {
                    const item = list[i];
                    const { id: _, ...data } = item;

                    try {
                        // Create a promise that rejects after 5 seconds
                        const timeoutPromise = new Promise((_, reject) =>
                            setTimeout(() => reject(new Error("Zaman aşımı (5sn)")), 5000)
                        );

                        // Race between write and timeout
                        await Promise.race([
                            addDoc(collection(db, name), { ...data, createdAt: new Date().toISOString() }),
                            timeoutPromise
                        ]);

                        success++;
                    } catch (err) {
                        console.error(`${name} [${i}] Hatası:`, err);
                        fail++;
                    }
                }

                if (fail > 0) {
                    setStatus(prev => prev + `⚠️ ${success} yazıldı, ${fail} başarısız.\n`);
                } else {
                    setStatus(prev => prev + `✅ Hepsi yazıldı.\n`);
                }
            };

            await writeOneByOne('events', eventsList);
            await writeOneByOne('announcements', announcementsList);
            await writeOneByOne('team', teamData);
            await writeOneByOne('press', pressItems);

            setStatus(prev => prev + '\n✨ İŞLEM TAMAMLANDI! ✨');

        } catch (error) {
            console.error(error);
            setStatus(prev => prev + `\n🛑 HATA OLUŞTU: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    const checkStatus = async () => {
        setLoading(true);
        setStatus('📊 Veritabanı durumu kontrol ediliyor...\n');
        try {
            const ev = await getDocs(collection(db, 'events'));
            const an = await getDocs(collection(db, 'announcements'));
            const tm = await getDocs(collection(db, 'team'));
            const bl = await getDocs(collection(db, 'blogs'));
            const mg = await getDocs(collection(db, 'magazines'));
            const pr = await getDocs(collection(db, 'press'));

            setStatus(prev => prev + `
            - Etkinlikler: ${ev.size} adet
            - Duyurular: ${an.size} adet
            - Ekip: ${tm.size} adet
            - Bloglar: ${bl.size} adet
            - Dergiler: ${mg.size} adet
            - Basında Biz: ${pr.size} adet
            \nKontrol Tamamlandı.`);
        } catch (error) {
            setStatus(prev => prev + `Hata: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-8 text-white max-w-4xl mx-auto">
            <h1 className="text-3xl font-bold mb-4">Veri Aktarımı ve Teşhis</h1>

            <div className="bg-gray-800 p-4 rounded-lg mb-6 border border-gray-600">
                <h3 className="text-lg font-bold mb-2 text-cyan-400">🔑 Sistem Durumu</h3>
                <p><strong>Giriş Yapan Kullanıcı:</strong> {auth.currentUser?.email || 'Giriş yapılmamış!'}</p>
                <p><strong>User ID:</strong> <code className="bg-black px-2 rounded">{auth.currentUser?.uid}</code></p>
                <div className="mt-4 p-3 bg-yellow-900/30 border border-yellow-600 rounded text-sm text-yellow-200">
                    <p className="font-bold">⚠️ DİKKAT: Eğer "Yazılıyor..." kısmında takılıyorsa, Firebase Kurallarınız yazmaya izin vermiyor olabilir.</p>
                    <p className="mt-2">Lütfen <a href="https://console.firebase.google.com/" target="_blank" className="underline">Firebase Console</a> {'>'} Firestore Database {'>'} Rules (Kurallar) sekmesine gidip şunları yapıştırın:</p>
                    <pre className="mt-2 bg-black p-3 block overflow-x-auto text-green-400 font-mono text-xs">
                        {`rules_version = '2';
service cloud.firestore {
  match /databases/{database}/documents {
    match /{document=**} {
      allow read: if true;
      allow write: if request.auth != null;
    }
  }
}`}
                    </pre>
                </div>
            </div>

            <p className="mb-4 text-gray-400">
                Bu araç `src/data` klasöründeki verileri Firebase Firestore veritabanına aktarır.
                <br />
                <strong>Yalnızca ilk kurulumda veya veri sıfırlamak istediğinizde kullanın.</strong>
            </p>

            <div className="flex gap-4 mb-8">
                <button
                    onClick={handleSeed}
                    disabled={loading}
                    className="bg-red-500 hover:bg-red-600 text-white px-6 py-3 rounded-lg font-bold disabled:opacity-50 flex items-center gap-2"
                >
                    {loading ? <span className="animate-spin">⏳</span> : '🚀'}
                    {loading ? 'İşlem Sürüyor...' : 'Verileri Aktar (Sıfırla)'}
                </button>

                <button
                    onClick={checkStatus}
                    disabled={loading}
                    className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg font-bold disabled:opacity-50"
                >
                    📊 Durum Kontrol
                </button>
            </div>

            <h3 className="text-xl font-bold mb-2">İşlem Günlüğü:</h3>
            <pre className="bg-black p-4 rounded-lg text-green-400 font-mono text-sm whitespace-pre-wrap h-96 overflow-auto border border-gray-700 shadow-inner">
                {status}
            </pre>
        </div>
    );
};

export default SeedData;
